

import { HTTPRequestType, PageOptions, PaginatedResponse } from 'src/services/api.types';
import { CreateMeetingProps, IMeeting, UpdateMeetingProps } from 'src/services/meetings/meetings.types';
import { rootApi } from '../rootApi';
import { IContactLink } from '../connections/connections.types';
import { EntityLinkType } from '../common.types';

const meetingsApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    getMeetingById: builder.query<IMeeting, string>({
      query: (id) => ({
        url: `/meetings/${id}`,
      }),
      providesTags: (result, error, id) => [{ type: 'Meetings', id }],
    }),
    getMeetings: builder.query<PaginatedResponse<IMeeting>, { page: number; per_page: number; search_query?: string }>({
      query: ({ page, per_page, search_query }) => ({
        url: `/meetings`,
        params: {
          page,
          per_page,
          search_query
        },
      }),
      providesTags: ['Meetings']
    }),
    createMeeting: builder.mutation<IMeeting, CreateMeetingProps>({
      query: (data) => ({
        url: `/meetings`,
        method: HTTPRequestType.POST,
        data
      }),
      invalidatesTags: ['Meetings'],
    }),
    updateMeeting: builder.mutation<IMeeting, { id: string; data: UpdateMeetingProps }>({
      query: ({ id, data }) => ({
        url: `/meetings/${id}`,
        method: HTTPRequestType.PUT,
        data
      }),
      invalidatesTags: (result, error, { id }) => [{ type: 'Meetings', id }],
    }),
    deleteMeeting: builder.mutation<void, string>({
      query: (id) => ({
        url: `/meetings/${id}`,
        method: HTTPRequestType.DELETE,
      }),
      invalidatesTags: (result, error, id) => ['Meetings'],
    }),

    validateMeetingPlatform: builder.mutation<{ platform?: string; supported: boolean, message?: string }, { url: string }>({
      query: ({ url }) => ({
        url: `/meetings/validate-platform`,
        method: HTTPRequestType.POST,
        data: { url }
      }),
    }),

    // contact links
    getMeetingContactLinks: builder.query<PaginatedResponse<IContactLink>, { meetingId: string, params: PageOptions & { search_query?: string } }>({
      query: ({ meetingId, params }) => ({
        url: `/meetings/${meetingId}/contact-links`,
        params,
      }),
      providesTags: (_res, _err, args) => [{ type: 'MeetingContactLink', id: args.meetingId }],
    }),
  }),
});

export const {
  useGetMeetingByIdQuery,
  useGetMeetingsQuery,
  useCreateMeetingMutation,
  useUpdateMeetingMutation,
  useDeleteMeetingMutation,

  useValidateMeetingPlatformMutation,

  useGetMeetingContactLinksQuery


} = meetingsApi;
